import React from 'react';
import PortalSignInFlow from '../components/PortalSignInFlow';

export default function DoctorLogin() {
  return (
    <PortalSignInFlow
      title="Doctor sign in"
      subtitle="Digitization portal — sign in with OTP, password, or Google for provisioned doctor emails."
      authKind="doctor"
      redirectPrefix="/doctor"
      defaultRedirect="/doctor/pending"
      lookupPath="/api/portal/doctor/lookup"
      passwordPath="/api/portal/doctor/login"
      sendOtpPath="/api/portal/doctor/send-otp"
      googlePath="/api/portal/doctor/google"
      otpPagePath="/doctor/login/otp"
      notProvisionedError="This email is not authorized for the digitization portal. Ask an admin to add you as a doctor user."
      googleDeniedError="Google Sign-In is only available for provisioned doctor emails. Use OTP or password, or ask an admin."
    />
  );
}
